import React from 'react';
import { ScrollView } from 'react-native-gesture-handler';
import AccountMenu from './menuItems/AccountMenu';
import CardExpiresMenu from './menuItems/CardExpiresMenu';
import HistoryMenu from './menuItems/HistoryMenu';
import SupportFeedbackMenu from './menuItems/SupportFeedbackMenu';
import VehiclePaymentMenu from './menuItems/VehiclePaymentMenu';
import SubPromotionCard from './subscription/SubPromotionCard';

const WelcomeSignedContent: React.FC = () => {
  return (
    <ScrollView style={{ paddingTop: 25 }}>
      <CardExpiresMenu />
      <SubPromotionCard isMenuItem />
      <HistoryMenu />
      <VehiclePaymentMenu />
      <SupportFeedbackMenu />
      <AccountMenu />
    </ScrollView>
  );
};

export default WelcomeSignedContent;
